import { api } from "infra/axios";

export async function useRegistroPcd(payload: FormData) {
  return await api.post('v1/crm/registro-pessoaespecial', payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}